import React from 'react';
import { ZoomSpinner } from '#/components/ZoomSpinner';
import { CircularProgressProps } from '@mui/material';

interface ButtonCircularProgressProps extends CircularProgressProps {
    isSubmitting?: boolean;
}

const ButtonCircularProgress: React.FC<React.PropsWithChildren<ButtonCircularProgressProps>> = ({ isSubmitting = false, ...props }) => (
    <ZoomSpinner show={isSubmitting} size={20} {...props} />
);

export default ButtonCircularProgress;
